import useSfmc from 'hooks/useSfmc';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { getUrlCountryPath } from 'utils/urlUtils';
import { setSfmcInitialized } from 'redux/ui/slice';

export const Sfmc = (props) => {
  const { dataset } = props;
  const dispatch = useDispatch();
  const [sfmcInstance, setSfmcInstance] = useState(null)
  const market = getUrlCountryPath();
  const { init } = useSfmc() || {};
  const [type, setType] = useState('text/javascript');

  // When no region in URL, set sfmcInitialized true so GTM/analytics are not blocked
  useEffect(() => {
    if (!market || market.length === 0) {
      dispatch(setSfmcInitialized(true));
    }
  }, [market, dispatch]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.SalesforceInteractions) {
        setSfmcInstance(window.SalesforceInteractions)
        clearInterval(intervalId)
      }
    }, 1000);

    return () => clearInterval(intervalId); 
  }, []);

  useEffect(() => {
    if(sfmcInstance) init();
  }, [init, sfmcInstance])
  

  // useEffect(() => {
  //   setType(oneTrustTargetingAccepted ? 'text/javascript' : 'text/plain');
  // }, [oneTrustTargetingAccepted]);

  return (
    <>
      {dataset && (
        <Helmet htmlAttributes={{ lang: market?.trim() || 'en' }}>
          <script
            type={type}
            src={`//cdn.evgnet.com/beacon/kyowakirinintlplc/${dataset}/scripts/evergage.min.js`}
          ></script>
        </Helmet>
      )}
    </>
  );
};

export default Sfmc;
